import { useState } from "react";
import { BodyDiv } from "../../components-style";
import { SubTitle, TextBody } from "../../typography";
import Input from "../inputs";
import { AnimatePresence, motion } from "framer-motion";
import { Button } from "../button";
import { COLORS } from "../../../assets/utils/enums/colors";
import CustomToast from "../custom-toast";
import toast from "react-hot-toast";
import { ToastTypeEnum } from "../../../assets/utils/enums/toast";
import { authFetch } from "../../../api/authFetch";
import { API_URL_COMMENT } from "../../../constants";
import { CommentTypeEnum } from "../../../assets/utils/enums/project";

export default function CommentAdd({ type, objectId, setIsLoading, setIsChangedComment }: { type: CommentTypeEnum; objectId: number; setIsLoading: React.Dispatch<React.SetStateAction<boolean>>; setIsChangedComment: React.Dispatch<React.SetStateAction<boolean>> }) {
    const [commentValue, setCommentValue] = useState<string>("");

    const handleAddComment = async () => {
        try {
            setIsLoading(true);
            if (!commentValue) return;

            const response = await authFetch(`${API_URL_COMMENT}/add-comment`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    content: commentValue,
                    [`${type}Id`]: objectId,
                }),
                credentials: "include",
            });

            if (!response.ok) {
                toast((t) => (
                    <CustomToast
                        t={t}
                        type={ToastTypeEnum.WARNING}
                        text={"Перевірте коректність введення даних!"}
                    />
                ));
                return;
            }
            toast((t) => (
                <CustomToast
                    t={t}
                    type={ToastTypeEnum.SUCCESS}
                    text={"Коментар додано!"}
                />
            ));
            setTimeout(() => {
                setCommentValue("");
                setIsChangedComment(true);
            }, 300);
        } catch (error) {
            console.error("Fetch error:", error);
            toast((t) => (
                <CustomToast
                    t={t}
                    text={"Упс, щось пішло не так\nПроблема з сервером."}
                    type={ToastTypeEnum.ERROR}
                />
            ));
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 150);
        }
    };

    return (
        <BodyDiv data-class="add-comment">
            <SubTitle>Додати коментар до цього проєкту:</SubTitle>
            <Input
                attribute="text"
                value={commentValue}
                setValue={setCommentValue}
                errorText={""}
                label=""
                placeholder="Введіть новий коментар тут.."
            />
            <AnimatePresence>
                {commentValue && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.2 }}
                        className="d-flex align-items-center mb-2 w-100 justify-content-end"
                    >
                        <Button
                            bgcolor={"transparent"}
                            txtcolor={COLORS["bg-text-color"]}
                            brcolor={"transparent"}
                            width="auto"
                            className="center-btn"
                            brradius="24px"
                            type="small"
                            onClick={() => {
                                setCommentValue("");
                            }}
                        >
                            <TextBody>Скасувати</TextBody>
                        </Button>
                        <Button
                            bgcolor={COLORS.secondary1}
                            txtcolor={COLORS.white}
                            brcolor={"transparent"}
                            width="auto"
                            className="center-btn"
                            brradius="24px"
                            type="small"
                            onClick={handleAddComment}
                        >
                            <TextBody>Зберегти</TextBody>
                        </Button>
                    </motion.div>
                )}
            </AnimatePresence>
            {/* <RichTextEditor /> */}
        </BodyDiv>
    )
}